import React from 'react';

const Layout = () => {

  return (
    <>
      <div className='spinner-container'>
        <div className="spinner"></div>
      </div>
    </>
  );
};

export default Layout;

// import React, { useState, useEffect } from 'react';

// const Layout = ({ children, isLoading = false }) => {
//   const [mounted, setMounted] = useState(false);

//   useEffect(() => {
//     setMounted(true);
//   }, []);

//   // Server render — return null to match client's initial state
//   if (!mounted) return null;

//   // Client only from here
//   if (isLoading) return (
//     <div className="spinner-container">
//       <div className="spinner"></div>
//     </div>
//   );

//   return <>{children}</>;
// };

// export default Layout;